import React, { useState } from "react";
import { Button, FormControl, Form, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as MdIcons from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import { IoCartSharp } from "react-icons/io5";
import { connect } from "react-redux";

function Header(props) {
  const [search, setSearch] = useState("");

  const hadnelRedirect = (value) => {
    if (value !== "/") {
      props.history.push(`/${value}`);
    } else {
      props.history.push(`/`);
    }
  };

  const handelSearchRedirect = (value) => {
    props.history.push(`/products/search/${value}`);
  };
  return (
    <header className="container-fluid ">
      <div
        className="my_navbar container-md d-md-flex align-items-center py-0 py-md-3"
        variant="dark"
      >
        <div className="pt-3 pt-md-0">
          <h1 className="m-0 text-center">
            <span style={{ color: "#e8491d" }}>SHOP</span> YOU
          </h1>
        </div>
        <div
          className="me-auto  ms-md-3 d-flex justify-content-center d-md-block"
          style={{ maxHeight: "100px" }}
        >
          <ul type="none" className="d-flex m-0 p-0 align-items-center">
            <li className="d-flex align-items-center">
              <Button
                className=" border-0"
                style={{ backgroundColor: "#35424a" }}
              >
                <Link
                  to="/"
                  className="text-decoration-none mt-2 me-2 text-white"
                >
                  Home
                </Link>
              </Button>
            </li>
            <li>
              <Dropdown>
                <Dropdown.Toggle
                  className="text-white border-0 mx-1"
                  style={{ backgroundColor: "#35424a" }}
                >
                  Electronics
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    className="w-100 d-block text-decoration-none text-dark ps-1"
                    onClick={() => {
                      handelSearchRedirect("mobile");
                    }}
                  >
                    Mobile
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="w-100 d-block text-decoration-none text-dark ps-1"
                    onClick={() => {
                      handelSearchRedirect("laptop");
                    }}
                  >
                    Laptop
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </li>
            <li>
              <Dropdown>
                <Dropdown.Toggle
                  className="text-white border-0"
                  style={{ backgroundColor: "#35424a" }}
                >
                  Fashion
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    className="w-100 d-block text-decoration-none text-dark ps-1"
                    onClick={() => {
                      handelSearchRedirect("top wear");
                    }}
                  >
                    Top Wear
                  </Dropdown.Item>

                  <Dropdown.Item
                    className="w-100 d-block text-decoration-none text-dark ps-1"
                    onClick={() => {
                      handelSearchRedirect("bottom wear");
                    }}
                  >
                    Bottom Wear
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </li>
          </ul>
        </div>
        <div className="d-flex justify-content-center align-items-center mt-1 mt-md-0 pb-4 pb-md-0">
          <Form className="d-block d-sm-inline-block flex-grow-1">
            <FormControl
              type="search"
              placeholder="Search Here...."
              className="mr-2"
              aria-label="Search"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
          </Form>
          <Link
            to={
              search.trim().length > 0
                ? `/products/search/${search}`
                : props.location.pathname
            }
            className="btn btn-primary ms-2"
            onClick={() => {
              setSearch("");
            }}
          >
            <FaSearch />
          </Link>

          <div className="ms-3">
            {props.username ? (
              <Dropdown>
                <Dropdown.Toggle
                  style={{ backgroundColor: "#35424a" }}
                  id="dropdown-basic"
                >
                  <MdIcons.MdAccountCircle
                    style={{ color: "#e8491d", fontSize: "25px" }}
                  />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => {
                      hadnelRedirect("profile");
                    }}
                  >
                    Profile
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      hadnelRedirect("profile/orders");
                    }}
                  >
                    Your Order's
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      hadnelRedirect("profile/cpass");
                    }}
                  >
                    Change Password
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      hadnelRedirect("/");

                      props.logoutUser();
                    }}
                  >
                    Log Out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <span>
                <Link
                  to="/login"
                  className="my_active text-decoration-none text-white"
                >
                  Login
                </Link>
              </span>
            )}
          </div>
          <div className="ms-2">
            <button type="button" className="btn btn-md position-relative">
              <Link to="/cart">
                <IoCartSharp style={{ color: "#e8491d", fontSize: "25px" }} />
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                  {props.cartLength}
                </span>
              </Link>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}

const mapStateToProps = (state) => {
  return {
    username: state.userDetails.username ? state.userDetails.username : null,
    cartLength: state.cart.length,
  };
};

const mapDispatchToProps = (dispacth) => {
  return {
    logoutUser: (val) => dispacth({ type: "LOG_OUT_USER", payload: val }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
